var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.109,
    height: 20.472,
    viewBox: "0 0 19.109 20.472",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "calendar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#758091",
    d: "M0,18.552a1.987,1.987,0,0,0,2.047,1.919H17.061a1.987,1.987,0,0,0,2.047-1.919V7.677H0Zm13.649-7.837a.5.5,0,0,1,.512-.48h1.706a.5.5,0,0,1,.512.48v1.6a.5.5,0,0,1-.512.48H14.161a.5.5,0,0,1-.512-.48Zm0,5.118a.5.5,0,0,1,.512-.48h1.706a.5.5,0,0,1,.512.48v1.6a.5.5,0,0,1-.512.48H14.161a.5.5,0,0,1-.512-.48Zm-5.46-5.118a.5.5,0,0,1,.512-.48h1.706a.5.5,0,0,1,.512.48v1.6a.5.5,0,0,1-.512.48H8.7a.5.5,0,0,1-.512-.48Zm0,5.118a.5.5,0,0,1,.512-.48h1.706a.5.5,0,0,1,.512.48v1.6a.5.5,0,0,1-.512.48H8.7a.5.5,0,0,1-.512-.48ZM2.73,10.716a.5.5,0,0,1,.512-.48H4.948a.5.5,0,0,1,.512.48v1.6a.5.5,0,0,1-.512.48H3.242a.5.5,0,0,1-.512-.48Zm0,5.118a.5.5,0,0,1,.512-.48H4.948a.5.5,0,0,1,.512.48v1.6a.5.5,0,0,1-.512.48H3.242a.5.5,0,0,1-.512-.48ZM17.061,2.559H15.014V.64A.664.664,0,0,0,14.331,0H12.967a.664.664,0,0,0-.682.64V2.559H6.824V.64A.664.664,0,0,0,6.142,0H4.777a.664.664,0,0,0-.682.64V2.559H2.047A1.987,1.987,0,0,0,0,4.478V6.4H19.109V4.478A1.987,1.987,0,0,0,17.061,2.559Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.6be6d5f1f0af035b3feea928572e0c95.svg";
export { ForwardRef as ReactComponent };